import { h, Component } from 'preact';
import { observer } from 'mobx-preact';
import { Text } from 'preact-i18n';

import { MAINTENANCE_TYPES, todayIso } from '../../lib/clubOps';

function initialState({ presetType }) {
    return {
        type: presetType || 'cleaned',
        date: todayIso(),
        note: '',
        installation: '',
        error: '',
        isSaving: false,
    };
}

@observer
class ClubOpsMaintenanceDrawer extends Component {
    constructor(props) {
        super(props);
        this.state = initialState(props);
    }

    componentDidMount() {
        const { installationStore } = this.props.stores;
        installationStore.load();
    }

    onField = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value, error: '' });
    }

    save = async () => {
        const { partMaintenanceStore, appState } = this.props.stores;
        const {
            part, callback = () => {}, drawerLevel = 1,
        } = this.props;
        const {
            type, date, note, installation,
        } = this.state;
        this.setState({ isSaving: true, error: '' });
        const response = await partMaintenanceStore.addEvent({
            part: part.id, type, date, note, installation,
        });
        if (response?.status === 201) {
            callback();
            appState.toggleDrawer(false, drawerLevel);
            return;
        }
        this.setState({ isSaving: false, error: response?.message || 'Could not save' });
    }

    render() {
        const { installationStore } = this.props.stores;
        const { installations = [] } = installationStore;
        const {
            type, date, note, installation, error, isSaving,
        } = this.state;

        return (
            <div class='w-100 d-flex justify-content-center'>
                <div class='w-100' style='max-width: 720px; padding-top: 20px; padding-bottom: 100px;'>
                    <div class='px-3'>
                        <h5 class='mb-3'>
                            <i class='fa-duotone fa-wrench me-2' />
                            <Text id='clubOps.maintenance-title'>Register weapon event</Text>
                        </h5>

                        <div class='mb-3'>
                            <label class='form-label'><Text id='clubOps.maintenance-type'>Type</Text></label>
                            <select class='form-select' name='type' value={type} onInput={this.onField}>
                                {MAINTENANCE_TYPES.map(t => <option key={t.key} value={t.key}>{t.label}</option>)}
                            </select>
                        </div>

                        <div class='row'>
                            <div class='col-6 mb-3'>
                                <label class='form-label'><Text id='clubOps.maintenance-date'>Date</Text></label>
                                <input class='form-control' type='date' name='date' value={date} onInput={this.onField} />
                            </div>
                            {type === 'moved' && (
                                <div class='col-6 mb-3'>
                                    <label class='form-label'><Text id='clubOps.maintenance-installation'>New storage location</Text></label>
                                    <select class='form-select' name='installation' value={installation} onInput={this.onField}>
                                        <option value=''>-</option>
                                        {installations.map(i => <option key={i.id} value={String(i.id)}>{i.name}</option>)}
                                    </select>
                                </div>
                            )}
                        </div>

                        <div class='mb-3'>
                            <label class='form-label'><Text id='clubOps.maintenance-note'>Note</Text></label>
                            <textarea class='form-control' name='note' rows='2' value={note} onInput={this.onField} />
                        </div>

                        {!!error && <div class='alert alert-danger py-2'>{error}</div>}

                        <div class='d-flex justify-content-end'>
                            <button type='button' class='btn btn-primary rounded-pill' disabled={isSaving} onClick={this.save}>
                                {!!isSaving && <span class='spinner-border spinner-border-sm me-2' />}
                                <i class='fa-solid fa-save me-1' />
                                <Text id='clubOps.maintenance-save'>Save</Text>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default ClubOpsMaintenanceDrawer;
